import script from "./SetExcludedSubscriptionDomainsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetExcludedSubscriptionDomainsModal.vue?vue&type=script&setup=true&lang=js"

import "./SetExcludedSubscriptionDomainsModal.vue?vue&type=style&index=0&id=21fe3c14&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fe3c14"]])

export default __exports__